exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vgt-table tr>td{padding:5px 10px!important;vertical-align:middle!important}.vgt-table .v-chip{width:90px}.vgt-table .v-list__tile{height:62px!important}.v-text-field--box.v-text-field--single-line input{margin-top:0!important}.v-small-dialog .v-menu__activator a{width:100%}.v-small-dialog .v-menu__activator a .td-km{display:flex;align-items:center;justify-content:space-around}.v-small-dialog .v-menu__activator a .td-def{display:flex;align-items:center}.v-small-dialog__actions button.v-btn{color:#01579b!important;caret-color:#01579b!important}.v-treeview-node__content{width:min-content}.v-treeview-node__content .v-treeview-node__label{width:inherit}.tree__wrap .el-scrollbar__wrap{overflow-x:hidden!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/TabVerificaTratta.vue?vue&type=style&index=0&lang=scss&
// module id = 862
// module chunks = 0